
$("a.list-social-link.print").click(function(e){
      e.preventDefault();
             window.print(); 
    
});
$('a.list-social-link.copy-link').click(function(e) {
    e.preventDefault();
    var $temp = $('<input>').val($(this).attr('href')).appendTo('body').select();
    document.execCommand('copy');
    $temp.remove();
    $(this).find('.alert-text').show();

    setTimeout(() => {
        $(this).find('.alert-text').hide();
    }, 1000);
});






$(document).on('click', '.heading-container', function(e) {
e.preventDefault();
$('.heading-container').removeClass('active_color');
  $(this).addClass('active_color');
  var index_val =  $(this).attr('data-index');
      
 $('.content-container .content-section').hide();
 $('.content-section[data-index="'+index_val+'"]').show();
  });



$(document).ready(function() {
var checkedInput = $('fieldset.js.product-form-input input[name="Length"]:checked');
    var variantDataNew = checkedInput.closest('fieldset').find('label[for="' + checkedInput.attr('id') + '"]').attr('variant_data_new');
 var variantDataSKU = checkedInput.closest('fieldset').find('label[for="' + checkedInput.attr('id') + '"]').attr('variant_sku');



    // console.log('Variant Data New:', variantDataNew);
   $('.product-info-details-item-value.new_variant').text(variantDataNew);
  $('.custom_ProductSku').text(variantDataSKU);

    $(document).on('click', '.product-form-input label', function() {
        var variantData = $(this).attr('variant_data_new');
 var variantSKU = $(this).attr('variant_sku');
 setTimeout(function() {
        $('.product-info-details-item-value.new_variant').text(variantData);
$('.custom_ProductSku').text(variantSKU);

},600);
    });
   
});

$(document).ready(function(){
    $('.custom_social .share_buton_wrp').hover(
        function() {
          
            $(this).find('.share_buton_wrp_data').show();
        },
        function() {
          
            $(this).find('.share_buton_wrp_data').hide();
        }
    );
});




